import { Component, OnInit, Input, ChangeDetectorRef, AfterContentInit, ChangeDetectionStrategy, HostBinding, ViewChild, ElementRef, Output, EventEmitter, OnDestroy, ViewRef, ViewEncapsulation } from '@angular/core';
import { UUID } from 'angular2-uuid';

export type ButtonIconInfo = {
  fas: boolean | string;
  far: boolean | string;
  icon: string;
  scale: string;
  left: string;
  top: string;
  leftMargin: string;
  topMargin: string;
  rotation: number;
  pitch: number;
  content: string;
  subicon: string;
  bufferable: string;
}

@Component({
  selector: 'app-button-icon',
  templateUrl: './button-icon.component.html',
  styleUrls: ['./button-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ButtonIconComponent implements AfterContentInit, OnDestroy {

  private contentReady = false;
  public classes = '';
  public buttonAction = '';
  private fontSize = '';
  private destroyed = false;
  @HostBinding('class.button-icon') buttonIconClass = true;
  @HostBinding('class.fas') isSolid = false;
  @HostBinding('class.far') isRegular = false;
  @HostBinding('class.fas-6') isSolid6 = false;
  @HostBinding('class.far-6') isRegular6 = false;
  @HostBinding('class.sub-icon') subIconClass = false;
  @HostBinding('class.sub-sm') subSm = false;
  @HostBinding('class.bufferable') bufferableClass = false;
  @HostBinding('class.custom') customClass = false;
  @HostBinding('class.no-icon') noIconClass = false;
  @HostBinding('id') id = UUID.UUID();
  @HostBinding('class.double-icon') isDoubleIcon = false;

  @Output() change = new EventEmitter<ButtonIconInfo>();



  @Input() set isDouble(isSet: boolean | string) {
    this.isDoubleIcon = [true, 'true'].indexOf(isSet) > -1;
    this.RefreshView();
  }

  // @HostBinding('style.max-width') maxWidthStyle = 'auto';
  @Input() set fas(isSet: boolean | string) {
    this.isSolid = [true, 'true'].indexOf(isSet) > -1;;
    this.RefreshView();
  }
  @Input() set far(isSet: boolean | string) {
    this.isRegular = [true, 'true'].indexOf(isSet) > -1;
    this.RefreshView();
  }
  // @HostBinding('style.max-width') maxWidthStyle = 'auto';
  @Input() set fas6(isSet: boolean | string) {
    this.isSolid6 = [true, 'true'].indexOf(isSet) > -1;;
    this.RefreshView();
  }
  @Input() set far6(isSet: boolean | string) {
    this.isRegular6 = [true, 'true'].indexOf(isSet) > -1;
    this.RefreshView();
  }

  @Input() set icon(classString: string) {
    this.classes = classString;
    if (this.classes !== '') {
      const classes = this.classes.split(' ');
      classes.every((value: string) => {
        this.domNode.nativeElement.classList.toggle(value, true);
        return true;
      });
    }
    this.RefreshView();
  }
  get icon(): string {
    return this.classes;
  }
  @Input() set bufferable(value: string) {
    this.bufferableClass = value === 'true';
  }
  get bufferable(): string {
    return this.bufferableClass === true ? 'true' : 'false';
  }
  @Input() set subicon(value: string) {
    if (value === 'true') {
      this.subIconClass = true;
      this.subSm = true;
    }
  }
  get subicon(): string {
    return this.subIconClass === true ? 'true' : 'false';
  }
  @Input() set scale(sizeVal: string) {
    this.fontSize = sizeVal;
    this.domNode.nativeElement.style.fontSize = this.fontSize;
    this.RefreshView();
  }
  get scale(): string {
    return this.fontSize;
  }
  @Input() set leftMargin(val: string) {
    this.domNode.nativeElement.style.marginLeft = val;
    this.RefreshView();
  }
  get leftMargin(): string {
    return this.domNode.nativeElement.style.marginLeft;
  }
  @Input() set topMargin(val: string) {
    this.domNode.nativeElement.style.marginTop = val;
    this.RefreshView();
  }
  get topMargin(): string {
    return this.domNode.nativeElement.style.marginTop;
  }
  private _angle: number = 0;
  @Input() set rotation(angle: number) {
    this._angle = angle;
    this.RefreshView();
    this.UpdateTransform();

  }
  get rotation(): number {
    return this._angle;
  }
  private _pitch: number = 0;
  @Input() set pitch(angle: number) {
    this._pitch = angle;
    this.RefreshView();
    this.UpdateTransform();

  }
  get pitch(): number {
    return this._pitch;
  }

  @Input() set left(leftVal: string) {
    this.domNode.nativeElement.style.setProperty('left', leftVal, 'important');
    this.RefreshView();
  }
  get left(): string {
    return this.domNode.nativeElement.style.left;
  }
  @Input() set top(topVal: string) {
    this.domNode.nativeElement.style.position = 'relative';
    this.domNode.nativeElement.style.setProperty('top', topVal, 'important');
    this.RefreshView();
  }
  get top(): string {
    return this.domNode.nativeElement.style.top;
  }
  @Input() set(pos: string) {
    //this.domNode.nativeElement.style.position = pos;
    //this.RefreshView();
  }
  get pos() {
    return this.domNode.nativeElement.style.position;
  }

  @Input()
  set symbol(sym: string) {
    const custom = sym.split(':');
    if (custom[0] !== 'custom') {
      this.customClass= false;
      this.RefreshView();
      return;
    }
    if (custom.length < 2) {
      this.customClass= false;
      this.RefreshView();
      return;
    }
    if (!this.contentReady) {
      window.requestAnimationFrame(() => {
        this.symbol = sym;
        this.customClass = true;
        this.RefreshView();
      })
      return;
    }

    const [font, symbol, size, offsetX, offsetY, theta] = custom[1].split(',');
    this.fas = false;
    this.far = false;
    this.domNode.nativeElement.style.setProperty('--symbol-family', font);
    this.domNode.nativeElement.style.setProperty('--symbol-char',`/${symbol}`)
    this.domNode.nativeElement.innerHTML=`&#x${symbol};`;
    this.rotation = 360-Number(theta);
    this.fontSize = size + 'pt';
    this.top = `${offsetY}px`;
    this.left = `${offsetX}px`;

  }

  RefreshView() {
    if (this.destroyed === true) {
      return;
    }

    if (this.contentReady === false) {
      window.requestAnimationFrame(() => {
        this.RefreshView();
      });
      return;
    }
    this.cdr.detectChanges();

    //window.requestAnimationFrame(() => {
    if (this.classes === '') {
      this.noIconClass = true;
    }
    // })
    this.change.emit(this.Clone());
  }
  constructor(private cdr: ChangeDetectorRef, private domNode: ElementRef<HTMLElement>) {

  }

  ngAfterContentInit(): void {
    this.contentReady = true;
    this.RefreshView();

  }
  Clone(): ButtonIconInfo {
    if (this.destroyed === false) {
      this.cdr.detectChanges();
    }
    return {
      far: this.isRegular,
      fas: this.isSolid,
      icon: this.icon,
      left: this.left,
      top: this.top,
      rotation: this.rotation,
      pitch: this.pitch,
      leftMargin: this.leftMargin,
      topMargin: this.topMargin,
      scale: this.scale,
      content: this.content,
      subicon: (this.subIconClass === true) ? 'true' : 'false',
      bufferable: this.bufferable
    }
  }
  @Input() set content(content: string) {
    this.domNode.nativeElement.innerHTML = content;
  }
  get content() {
    return this.domNode.nativeElement.innerHTML;
  }
  UpdateTransform() {
    let transform = '';
    if (!!this._pitch) {
      transform += 'rotate3d(1,0,0,' + this._pitch + 'deg)';
      transform += ' ';
    }
    if (!!this._angle) {

      transform += 'rotate3d(0,0,1,-' + (this._angle % 360) / 360 + 'turn)';
    }
    this.domNode.nativeElement.style.transform = transform;

  }

  ngOnDestroy() {
    this.destroyed = true;
    this.cdr.detach();
  }
}
